import React, { forwardRef } from 'react';
import classNames from 'classnames';
import SliderModule from 'react-slick';
import { useRouter } from 'next/router';

import { useBusiness } from '@/hooks/useBusiness';
import PrevArrow from '../SliderArrows/PrevArrow';
import NextArrow from '../SliderArrows/NextArrow';

import styles from './styles.module.scss';

const SliderWrapper = forwardRef(
  (
    {
      children,
      options,
      className,
      style = {},
      arrows,
      nextArrow,
      prevArrow,
      shadow,
    },
    ref,
  ) => {
    const business = useBusiness();
    const router = useRouter();
    const settings = {
      infinite: true,
      dots: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 1500,
      pauseOnHover: true,
      // variableWidth: true,
      lazyLoad: 'ondemand',
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            arrows: false,
            dots: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 767,
          settings: {
            infinite: true,
            arrows: false,
            dots: true,
            slidesToShow: 1,
          },
        },
      ],
      ...options,
    };

    if (arrows) {
      settings.nextArrow = nextArrow ?? <NextArrow className={'slick-next'} />;
      settings.prevArrow = prevArrow ?? <PrevArrow className={'slick-prev'} />;
      settings.infinite = options?.infinite;
      settings.arrows = true;
      settings.autoplay = true;
    }
    return (
      <div
        className={classNames(styles.slider__wrapper, 'wrapper', {
          [styles.slider__wrapper__business]: business,
        })}
        itemScope
        itemType='https://schema.org/Offer'
      >
        <SliderModule
          {...settings}
          style={style}
          ref={ref}
          className={classNames([
            'autoplay',
            styles.slider,
            className,
            {
              [styles.arrows]: !!arrows,
              [styles.shadow]: !!shadow,
              [styles.arrowsWhite]: !router.pathname.includes('/business'),
            },
          ])}
        >
          {children}
        </SliderModule>
      </div>
    );
  },
);
SliderWrapper.displayName = 'SliderWrapper';

export default SliderWrapper;
